/* src/app/cardholders/visitor-cards/visitor-card-details/visitor-card-details.component.css */
/*# sourceMappingURL=visitor-card-details.component.css.map */
